import { QueryClient } from '@tanstack/react-query';

/**
 * React Query configuration
 * Customize these defaults based on your application needs
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data will be considered stale after 30 minutes
      staleTime: 30 * 60 * 1000, // 30 minutes

      // Cache data for 60 minutes
      gcTime: 60 * 60 * 1000, // 60 minutes

      // Retry failed requests 3 times with exponential backoff
      retry: 0,

      // Don't refetch on window focus by default (can enable per-query if needed)
      refetchOnWindowFocus: false,

      // Refetch on mount if data is stale
      refetchOnMount: true,

      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});
